import { render, staticRenderFns } from "./mobile-invitation-form.vue?vue&type=template&id=a479ae50&scoped=true"
import script from "./mobile-invitation-form.vue?vue&type=script&lang=js"
export * from "./mobile-invitation-form.vue?vue&type=script&lang=js"
import style0 from "./mobile-invitation-form.vue?vue&type=style&index=0&id=a479ae50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a479ae50",
  null
  
)

export default component.exports